module.exports = __webpack_public_path__ + "static/media/nohas.8c6fdc9a.jpg";